import { authFetch } from '@/services/api.service';
import type { DiscrepancyItem, DiscrepancyFilters, DiscrepancyAdjustment, DiscrepancySummaryData } from '@/types/discrepancy-review.types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

export interface DiscrepancyResponse {
  success: boolean;
  data: DiscrepancyItem[];
  meta: DiscrepancySummaryData;
}

export interface AdjustmentResponse {
  success: boolean;
  message: string;
  data: {
    adjustmentsCreated: number;
    movements: Array<{
      ingredientId: number;
      sourceType: string;
      sourceId: number;
      direction: string;
      quantity: number;
      movementId: number;
    }>;
  };
  errors?: Array<{ ingredientId: number; sourceId: number; error: string }>;
}

class DiscrepancyReviewService {
  private baseUrl = `${API_BASE_URL}/discrepancy-review`;

  async getDiscrepancies(filters: DiscrepancyFilters): Promise<DiscrepancyResponse> {
    const params = new URLSearchParams();
    params.append('locationId', filters.locationId);

    if (filters.shift !== 'all') params.append('shift', filters.shift);
    if (filters.type !== 'all') params.append('type', filters.type);
    if (filters.categoryId) params.append('categoryId', filters.categoryId);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.onlyDiscrepancies) params.append('onlyDiscrepancies', 'true');

    const response = await authFetch(`${this.baseUrl}?${params.toString()}`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  }

  async applyAdjustments(locationId: string, items: DiscrepancyAdjustment[]): Promise<AdjustmentResponse> {
    const response = await authFetch(`${this.baseUrl}/apply-adjustments`, {
      method: 'POST',
      body: JSON.stringify({ locationId, items }),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  }
}

export const discrepancyReviewService = new DiscrepancyReviewService();
